<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/unidades-medida`;
const token = utilsService.getToken();

function buildPayload(formRaw) {
  return {
    codigo: formRaw.codigo,
    codigoEn: formRaw['codigoEn'],
    nombre: formRaw.nombre,
    nombreEn: formRaw['nombreEn'],
    simbolo: formRaw.simbolo,
    tipo: formRaw.tipo,
    tipoEn: formRaw['tipoEn'],
    orden: formRaw.orden,
    factorConversionBase: formRaw.factorConversionBase,
    idUnidadBase: formRaw.idUnidadBase,
    esBase: formRaw.esBase,
    permiteDecimales: formRaw.permiteDecimales,
    descripcion: formRaw.descripcion,
    descripcionEn: formRaw['descripcionEn'],
  };
}

const unidadMedidaService = {
  async getAll() {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async get(id) {
    try {
      const response = await axios.get(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      window.location.href = '/error';
    }
  },

  async create(formRaw) {
    try {
      const form = buildPayload(formRaw);

      const response = await axios.post(apiUrl, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response;
    } catch (error) {
      // Si viene de Axios, re-lanzar tal cual para conservar response.status y response.data
      if (error && error.response) {
        throw error;
      }
      throw {
        response: {
          status: 0,
          data: (error && error.message) ? error.message : 'Error en la solicitud.',
        },
      };
    }
  },

  async update(formRaw, id) {
    try {
      const form = buildPayload(formRaw);

      const response = await axios.put(`${apiUrl}/${id}`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al actualizar la unidad de medida.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },

  async deleteBy(id) {
    try {
      const response = await axios.delete(`${apiUrl}/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },
};

export default unidadMedidaService;
</script>
